<template>
    <div>
        <rkm-area
            title="Paciente"
            type="fieldset"
            no-margin-top
            v-if="pacienteExists"
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ form.paciente.cidadao.nome }}
                                <template v-if="form.paciente.cidadao.nomeSocial">
                                    <template v-if="form.paciente.cidadao.nomeSocial">
                                        <strong>({{ form.paciente.cidadao.nomeSocial }})</strong>
                                    </template>

                                    <template v-else>
                                        ({{ form.paciente.cidadao.nomeSocial }})
                                    </template>
                                </template>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>Prontuário:</strong>
                                {{ form.paciente.prontuario }}
                            </p>
                            <p>
                                <strong>Telefone:</strong>
                                {{ form.paciente.cidadao.telefonePrincipal ? formatPhoneOrCellPhone(form.paciente.cidadao.telefonePrincipal.numero) : ' - ' }}
                            </p>
                            <p>
                                <strong>Sexo:</strong>
                                <template v-if="form.paciente.cidadao.sexo">
                                    {{ form.paciente.cidadao.sexo.descricao }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>CPF:</strong>
                                <template v-if="form.paciente.cidadao.cpf">
                                    {{ form.paciente.cidadao.cpf ? formatCpf(form.paciente.cidadao.cpf) : ' - ' }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Data de nascimento:</strong>
                                {{ form.paciente.cidadao.dataNascimento ? formatDate(form.paciente.cidadao.dataNascimento) : ' - ' }}
                            </p>
                            <p>
                                <strong>
                                    Nome da mãe:
                                </strong>
                                <template v-if="form.paciente.cidadao.nomeMae">
                                    {{ form.paciente.cidadao.nomeMae }}
                                </template>
                                <template v-else>
                                    <i>Desconhecido</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>CNS:</strong>
                                <template v-if="form.paciente.cidadao.cns">
                                    {{ form.paciente.cidadao.cns ? formatCns(form.paciente.cidadao.cns) : ' - ' }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Idade:</strong>
                                <template v-if="form.paciente.cidadao.idade">
                                    {{ form.paciente.cidadao.idade.anos }} anos,
                                    {{ form.paciente.cidadao.idade.meses }} meses e
                                    {{ form.paciente.cidadao.idade.dias }} dias
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                            <p>
                                <strong>Unidade de referência:</strong>
                                <template v-if="form.paciente.unidade">
                                    {{form.paciente.unidade.nomeFantasia}}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Dados do pedido"
            type="fieldset"
            no-margin-top
            class="mt-3"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <p>
                        <strong>Exame:</strong>
                        <template v-if="model">
                            {{model.exameNome}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </p>
                    <p>
                        <strong>Médico solicitante:</strong>
                        <template v-if="form.agendamento">
                            {{form.agendamento.medicoNome}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </p>
                </rkm-col>
                <rkm-col>
                    <p>
                        <strong>Unidade solicitante:</strong>
                        <template v-if="form.agendamento">
                            {{form.agendamento.unidadeSolicitanteNome}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </p>
                        <p>
                        <strong>Unidade executante:</strong>
                        <template v-if="form.agendamento">
                            {{form.agendamento.unidadeNome}}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </p>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-form
            v-if="model"
            ref="Form"
        >
            <rkm-area
                class="mt-4"
                title="Laudo médico"
                type="fieldset"
                no-margin-top
            >
                <rkm-text-editor
                    label="Resultado"
                    v-model="model.resultado"
                    :validations="validations.resultado"
                />

                <rkm-form-group class="p-0">
                    <template
                        v-if="label || model.historico.length > 0"
                        slot="label"
                    >
                        <rkm-row>
                            <rkm-col align-self="end" cols="6">
                                {{(!readonly && validations && validations.required ? ' *' : '') }}
                            </rkm-col>

                            <rkm-col class="text-right" cols="6">
                                <rkm-button
                                    v-if="model.historico.length > 0"
                                    @click.stop="visible = !visible"
                                >
                                    {{ buttonLabel ? buttonLabel : `${model.historico.length} registro(s)` }}
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-if="readonly">
                        <rkm-list
                            :items="model.historico"
                            hide-filters
                            hide-pagination
                        >
                            <template v-slot="{ item }">
                                <div>Data: {{ item.data }} às {{ item.horario }}</div>
                                <div class="html" v-html="item.resultado"></div>
                            </template>
                        </rkm-list>
                    </template>

                    <template v-else>
                        <rkm-collapse
                            v-if="model.historico.length > 0"
                            :visible="visible"
                            class="mb-1"
                        >
                            <rkm-list-group>
                                <rkm-list-group-item
                                    v-for="(item, i) in model.historico"
                                    v-bind:key="i"
                                >
                                    <div>Data: {{ item.data }} ás {{ item.horario }}</div>
                                    <div class="html" v-html="item.resultado"></div>
                                </rkm-list-group-item>
                            </rkm-list-group>
                        </rkm-collapse>
                    </template>
                </rkm-form-group>
            </rkm-area>

            <rkm-area
                title="Laudos"
                class="p-2"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-file
                            label="Laudos"
                            v-model="local.laudo"
                            type="file"
                            placeholder="SELECIONE UM LAUDO"
                            accept=".pdf"
                            browse-text="Selecionar"
                            drop-placeholder="Arraste e solte aqui..."
                            ref="file-input"
                            :disabled="desabilitaFile ? true : false"
                        >
                            Pesquisar
                        </rkm-form-file>
                    </rkm-col>
                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            @click.stop="addLaudos()"
                            color="primary"
                            ref="file-input"
                            :label="false"
                            :disabled="desabilitaFile ? true : false"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click.stop="resetForm"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-table
                    :items="model.laudos"
                    :fields="fields.tables.laudo"
                    hide-filters
                >
                    <template v-slot:cell(dados)="row">
                        {{ row.item.laudoNome }}
                    </template>

                    <template v-slot:cell(actions)="{ index, item }">

                         <rkm-button
                           :disabled="item.salvo == false"
                           @click="handleDownload(item)"
                            color="primary"
                            small
                            title="Visualizar"
                        >
                            <rkm-icon icon="download" />
                        </rkm-button>

                        <rkm-button
                            :disabled="item.salvo == true"
                            color="danger"
                            @click="removeLaudo(index)"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, data, stringCase, formats } from '@/mixins'

//Enuns.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

// Moment.
import moment from 'moment'

export default {
    computed: {
        pacienteExists() {
            return this.form && this.form.paciente
        },
        validations() {

            return {
                resultado: {
                    max: 3500,
                    min: 3,
                },
            }
        },
        fields(){
            return {
                tables: {
                    laudo: [
                        { key: 'dados', label: 'Laudo', class: 'align-middle' },
                        { key: 'laudoData', label: 'Data laudo', class: 'align-middle' },
                        { key: 'laudoHora', label: 'Horário laudo', class: 'align-middle' },
                        { key: 'actions', label: 'Ações', class: 'col-min' }
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            alteracaoResultado: this.getConectaSusRepository('exameImagem.alteracaoResultadoLancamento'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        }
        this.load()
    },
    data: () => ({
        local: {
            laudo: null
        },
        model: null,
        form: {
            paciente: {
                cidadao:[]
            },
        },
        enums: {
            preferenciaNome,
            statusFechamento
        },
        items: [],
        desabilitaTextarea: false,
        desabilitaFile: false,
        desabilitaBotao: false,
        visible: false,
        label: null,
        buttonLabel: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.alteracaoResultado.edit(this.id)
                .then(({ data }) => {

                    if (data.model) {

                        if(data.model.laudos == null || data.model.laudos.length > 0){

                            data.model.resultado == null

                        } else if(data.model.resultado == null){

                            data.model.resultado = data.model.resultadoParametrizacao
                        }

                        this.form = this.clone(data.form)
                        this.model = this.clone(data.model)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addLaudos(){

            if(this.local.laudo == null){

                this.showValidationNotification("É necessário incluir um arquivo.")
                return
            }

            var numeroProntuario = this.form.paciente.prontuario

            const param = {
                arquivo: this.local.laudo,
                nomeArquivo: numeroProntuario + new Date().getTime() + '_' + this.model.exameNome.split(" ").join("_")
                    .replaceAll('(','_').replaceAll(')','').replaceAll('+','_'),
                laudoNome: numeroProntuario + new Date().getTime() + ' - ' + this.model.exameNome,
                laudoData: moment(new Date()).format('DD/MM/YYYY'),
                laudoHora: moment(new Date()).format('HH:mm'),
                salvo: false
            }

            this.model.laudos.push(this.clone(param))

            this.model.laudos.find(verifica => {
                if(verifica.salvo == false){
                    this.disabledFile()
                }
            })
        },
        disabledDownload(){

            this.model.laudos.filter(p => {

                if(p.laudoHora){

                    this.desabilitaBotao = true
                }
            })


        },
        disabledBotao(){

            this.desabilitaBotao = true
        },
        resetForm() {

            this.local.laudo = null
            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        disabledTextarea(){

            this.desabilitaTextarea = true
            this.model.resultado = null
        },
        disabledFile(){

            this.desabilitaFile = true
            this.local.laudo = null
        },
        removeLaudo(index) {

            const objId = this.model.laudos.findIndex((obj =>obj.id == index.id));

            const destroy = async () => {

                this.model.laudos.splice(objId, 1)
                this.desabilitaTextarea = false
                this.desabilitaFile = false
            }

            this.showDeleteConfirmation('Deseja realmente excluir o laudo?', destroy)
        },
        save(){

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.alteracaoResultado.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()

                            if(this.model.laudos == ''){

                                this.imprimir(this.model)

                            } else if(this.model.resultado == null){

                                 this.showSaveNotification()
                            } else if(this.model.laudos.length > 0){

                                this.imprimir(this.model)
                            } else {

                                this.showSaveNotification(`Laudo importado com sucesso.`)
                            }

                            this.$emit('save', data)

                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        imprimir(data) {

            this.setLoading()

            this.repositories.impressao.lancamento(data.idPaciente)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        handleDownload(item) {

            this.repositories.alteracaoResultado.download(item.id)
                .then(response => {

                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')

                    link.href = window.URL.createObjectURL(blob)
                    link.download = file

                    link.click()
                })
                .catch(this.handleError)
        },
        prepareData() {

            let formData = new FormData()

            formData.append('id', this.id)
            formData.append('exame_id', this.model.exameId)
            formData.append('id_paciente', this.model.idPaciente)
            formData.append('usuario_id', this.form.usuarioId)

            if(this.model.statusId != null){

                formData.append('status_id', this.enums.statusFechamento.REALIZADO)
                formData.append('status_troca', 1)
            } else {

                formData.append('status_troca', 0)
            }

            if(this.model.resultado != null){
                formData.append('resultado', this.model.resultado)
            }

            this.model.laudos.filter(laudo => !laudo.id).forEach((value) => {

                formData.append('laudos[]', new File([value.arquivo], `${value.nomeArquivo}.${value.arquivo.name.split('.').pop()}`))

                formData.append('arquivo', `${value.nomeArquivo}.${value.arquivo.name.split('.').pop().toUpperCase()}`)

                formData.append('laudo_nome', `${value.laudoNome}`)

                formData.append('laudo_data', `${value.laudoData}`)
            });

            return formData
        },
    },
    mixins: [repository, error, object, data, stringCase, formats],
    props: {
        id: { type: Number },
        readonly: { type: Boolean, default: false },
    },
}
</script>
<style scoped>

p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>
